import { Button, Card, Typography } from "antd";
import ThemeSwitcher from "./ThemeSwitcher";

const { Title } = Typography;

export const ThemeSettings = () => {
  return (
    <Card title="Theme Settings" variant="borderless">
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div>
          <Title level={5}>Theme Mode and Colors</Title>
          <p>Choose your preferred theme mode and colors</p>
          <ThemeSwitcher />
          <Button type="primary">Click me</Button>
        </div>
      </div>
    </Card>
  );
};

export default ThemeSettings;
